import React, { useEffect, useRef, useState } from "react";

import { FormButton } from "components";
import { FormikTextInput } from "components/UI/Inputs/FormikInputs";
import { Form, Formik } from "formik";
import * as yup from "yup";

import { useRecoilValue, useSetRecoilState } from "recoil";
import {
    snackbarData,
    userCredentials,
} from "recoilState/GlobalState";

import styles from "styles/pages/ModalActions.module.scss";
import { RNHUnidadGet } from "services/services-mia/RNHUnidadGet";
import { RNHUnidadUpd } from "services/services-mia/RNHUnidadUpd";

export default function UpdateModal({ updateList, user, closeModal }) {
    const setSnackBarInfo = useSetRecoilState(snackbarData);
    const credentials = useRecoilValue(userCredentials);
    const formikRef = useRef();
    const [data, setData] = useState();
    const [isLoading, setIsLoading] = useState(false);
    const [inRequest, setInRequest] = useState(false);

    const getServicioData = async () => {
        setIsLoading(true);
        const result = await RNHUnidadGet(credentials, { id: user.id })
        formikRef.current.setValues({
            id: result[0].rnhUnidadId,
            nombre: result[0].rnhUnidadNombre,
            cod: result[0].rnhUnidadCod,
            desc: result[0].rnhUnidadDescripcion,
        });
        setData(result[0]);
        setIsLoading(false);
    }
    const handleSubmit = async (values) => {
        const response = await RNHUnidadUpd(credentials, {
            id: data.rnhUnidadId,
            name: values.nombre,
            cod: values.cod,
            desc: values.desc,
            version: data.rnhUnidadVersion,
        })
        if (response.length === 0) {
            setSnackBarInfo({
                message: "Unidad modificada correctamente",
                severity: "success",
                open: true,
            });
            formikRef.current.resetForm();
            updateList();
            closeModal();
        }
    };
    useEffect(() => {
        getServicioData()
    }, []);
    return (
        <Formik
            innerRef={formikRef}
            initialValues={{
                nombre: "",
                cod: "",
                desc: ""
            }}
            validationSchema={
                yup.object({
                    nombre: yup.string("Debe ingresar un nombre").max(45, "Debe tener menos de 45 caracteres").required("Debe ingresar un nombre"),
                    cod: yup.string("Debe ingresar un código").max(20, "Debe tener menos de 20 caracteres").required("Debe ingresar un código"),
                    desc: yup.string("Debe ingresar una descripción").max(150, "Debe tener menos de 150 caracteres").required("Debe ingresar una descripción"),
                })
            }
            onSubmit={(values) => {
                handleSubmit(values);
            }}
        >
            <Form className={styles.inputs} noValidate>
                <div className={styles["column"]}>
                    <FormikTextInput
                        fullWidth={true}
                        name="nombre"
                        placeholder=""
                        labelText="Nombre de la unidad"
                    />
                    <FormikTextInput
                        fullWidth={true}
                        name="cod"
                        placeholder=""
                        labelText="Código de la unidad"
                    />
                    <FormikTextInput
                        fullWidth={true}
                        name="desc"
                        placeholder=""
                        labelText="Descripción de la unidad"
                        multiline
                    />
                    <FormButton
                        inRequest={inRequest}
                        newFormData={{ button: "Modificar" }}
                        onCloseModal={closeModal}
                    />
                </div>
            </Form>
        </Formik>
    );
}
